Vue.component('orders', {
    props: ['user'],
    data: function(){
        return {
        }
    },
    mounted: function(){

    },
    methods: {
    },
});
